import ActionTypes from "../../../../constants/ActionTypes";
import { ICampaignSoftElectroState } from "./types";
import { CampaignConstants } from "../../../../constants/CampaignConstants";

const initialState: ICampaignSoftElectroState = {
  submitStatus: CampaignConstants.softElectro.submitCodes.SUCCESS,
  submitMessage: ''
};

const campaignSoftElectroReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.CAMPAIGN.SOFT_ELECTRO.SET_SUBMIT_STATUS:
    return {
      ...state,
      submitStatus: action.payload
    };
  case ActionTypes.CAMPAIGN.SOFT_ELECTRO.SET_SUBMIT_MESSAGE:
    return {
      ...state,
      submitMessage: action.payload
    };
  }
  return state;
};

export default campaignSoftElectroReducer;

